<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content class="ro-form" [formGroup]="form">
  <div class="form-grid two-col">
    <mat-form-field appearance="outline" class="wide-field">
      <mat-label>Site name</mat-label>
      <input matInput formControlName="siteName" />
      <mat-error *ngIf="form.get('siteName')?.hasError('required')">Required</mat-error>
      <mat-error *ngIf="form.get('siteName')?.hasError('maxlength')">Maximum 200 characters</mat-error>
    </mat-form-field>
  </div>

  <div class="form-grid two-col">
    <mat-form-field appearance="outline" class="wide-field">
      <mat-label>Address</mat-label>
      <input matInput formControlName="addressLine1" />
      <mat-error *ngIf="form.get('addressLine1')?.hasError('maxlength')">Maximum 200 characters</mat-error>
    </mat-form-field>
  </div>

  <div class="form-grid two-col">
    <mat-form-field appearance="outline">
      <mat-label>City</mat-label>
      <input matInput formControlName="city" />
      <mat-error *ngIf="form.get('city')?.hasError('maxlength')">Maximum 100 characters</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Postal code</mat-label>
      <input matInput formControlName="postalCode" />
      <mat-error *ngIf="form.get('postalCode')?.hasError('maxlength')">Maximum 20 characters</mat-error>
    </mat-form-field>
  </div>

  <div class="form-grid two-col">
    <!-- The tenant's own catalog, not a text box. Typing this field is what
         made "30 yd", "30yd" and "30 Yard" three sizes; picking a row makes
         them one, and leaves the wording the tenant's to change. -->
    <mat-form-field appearance="outline">
      <mat-label>Container size</mat-label>
      <mat-select formControlName="containerTypeId">
        <!-- Explicit, because a hire is quoted long before anyone decides
             which box goes on the site. Without it the only way to leave the
             size open is never to touch the field. -->
        <mat-option [value]="null">Not decided yet</mat-option>
        <mat-option *ngFor="let size of containerTypes" [value]="size.id">
          {{ sizeLabel(size) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Quoted price</mat-label>
      <input matInput type="number" min="0" step="0.01" formControlName="quotedPrice" />
      <mat-error *ngIf="form.get('quotedPrice')?.hasError('min')">Cannot be negative</mat-error>
      <mat-error *ngIf="form.get('quotedPrice')?.hasError('max')">Too large</mat-error>
    </mat-form-field>
  </div>

  <!-- What this hire had written on it before the catalog existed, when the
       backfill could not place it. Kept in front of the person who can say
       which size it meant, rather than left in a column nobody opens. -->
  <p class="ro-unplaced-size" *ngIf="unplacedSizeText as typed">
    <br-icon>history_edu</br-icon>
    Recorded as “{{ typed }}” before there was a size list. Pick the size it
    meant — the original wording stays on the record either way.
  </p>

  <p class="ro-unplaced-size" *ngIf="containerTypesError">
    <br-icon>error_outline</br-icon> {{ containerTypesError }}
  </p>

  <div class="form-grid two-col">
    <app-date-field label="Rental starts" formControlName="hireStartsOn"></app-date-field>
    <app-date-field label="Rental ends" formControlName="hireEndsOn"></app-date-field>
  </div>

  <div class="form-grid two-col">
    <mat-form-field appearance="outline">
      <mat-label>Sales rep</mat-label>
      <mat-select formControlName="salesRepUserId">
        <mat-option [value]="null">Unassigned</mat-option>
        <mat-option *ngFor="let rep of data.reps" [value]="rep.userId">
          {{ repLabel(rep) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- The stage is absent on purpose: a hire starts at the front of the
       vocabulary and moves only by a transition that records who and why. -->

  <mat-error *ngIf="error" class="dialog-error">{{ error }}</mat-error>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="br-btn br-btn--secondary" (click)="cancel()" [disabled]="saving">Cancel</button>
  <button type="button" class="br-btn br-btn--primary"
          (click)="save()" [disabled]="saving">
    {{ saving ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
